import React from 'react';
import styled from 'styled-components';
import FillingDisplay  from "./FilingDisplay"
const Wrapper = styled.div`
  margin: 10px;
  padding: 12px;
  font-family: 'Segoe UI', sans-serif;
`;

const QuestionCard = styled.div`
  background: #ffffff;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

const QuestionHeader = styled.h3`
  font-size: 16px;
  color: #333;
  margin-bottom: 0px;
  display: flex;
  align-items: center;

`;

const QuestionType = styled.span`
  font-size: 12px;
  color: #666;
  margin-bottom: 0.5rem;
  display: block;
`;

const QuestionImage = styled.img`
  max-width: 100%;
  max-height: 200px;
  margin: 0.75rem 0;
  border-radius: 8px;
`;

const AudioPlayer = styled.audio`
  margin: 0.5rem 0;
  width: 100%;
`;

const UserAnswer = styled.p`
  font-size: 1rem;
  color: ${(props) => (props.correct ? '#2e7d32' : '#d32f2f')};
  font-weight: ${(props) => (props.correct ? '600' : '400')};
  text-decoration: ${(props) => (props.correct ? 'none' : 'line-through')};
  margin-bottom:6px;
`;

const CorrectAnswer = styled.p`
  font-size: 0.95rem;
  color: #2e7d32;
  margin-top: 0;
  margin-bottom:0px;
`;

const QuestionPreview = ({ question, answer ,q_id}) => {
  if (!question) return null;
  const question_obj =  question.question||{}
  const { question:question_text, correct_answer  , highlightWords } = question_obj;
  const image = question_obj.image || question.image;
  const question_audio = question_obj.question_audio || question.question_audio;
  // answer..
  const isCorrect = answer?.isCorrect;
  const userAnswer = answer?(answer.value?.trim() || ''):'';
  
  if (userAnswer === '') {
    return null;
  }
  
  return (
    <Wrapper>
      <QuestionCard key={question.id}>
        {/* <QuestionType>Type: {question.type}</QuestionType> */}
        
        <QuestionHeader>{q_id ? q_id : ''}. {question.question_type == "Fill_IN_THE_Blank" ? <FillingDisplay
          text={question_text}
          highlights={highlightWords}
          is_correct={isCorrect}
          answer_text={userAnswer}
        /> : question_text}
        </QuestionHeader>
        {image && <QuestionImage src={image} alt="question visual" />}
        {question_audio && (
          <AudioPlayer controls>
            <source src={question_audio} type="audio/mpeg" />
          </AudioPlayer>
        )}

       <UserAnswer correct={isCorrect}>
           Student Answer: {userAnswer || <em style={{ color: '#999' }}>No answer</em>}
        </UserAnswer>
        {!isCorrect && (
          <CorrectAnswer>Answer: {correct_answer}</CorrectAnswer>
        )}
      </QuestionCard>
    </Wrapper>
  );
};

export default QuestionPreview;
